import emit from '../../common/events';
import store from '../../store/store';
import { BaseComponent } from '../base-component/base-component';
import { connect } from 'pwa-helpers';
import { customElement, property, state } from 'lit/decorators.js';
import { html } from 'lit';

/**
 * A static element to display the checkout terms and conditions checkbox.
 */
@customElement('mhecomm-checkout-terms-acceptance')
export class CheckoutTermsAcceptance extends connect(store)(BaseComponent) {
  /**
   * The event name to be emitted when the checkout terms acceptance checkbox is checked or unchecked.
   */
  @property({type: String})
  eventName = 'mhecomm-checkout-terms-updated';

  /**
   * The label for the checkout terms acceptance checkbox.
   */
  @property({type: String})
  label = 'I agree to the Terms and Conditions';

  /**
   * Flag to indicate if the user has accepted the checkout terms.
   */
  @state()
  private areTermsAccepted = false;

  renderComp() {
    return html`
      <div class="form-check">
        <label for="checkout-terms-acceptance" class="fs-small">${this.label}</label>
        <input class="form-check-input"
          type="checkbox"
          id="checkout-terms-acceptance"
          name="checkout-terms-acceptance"
          aria-label="${this.label}"
          @change="${this.modifyCheckoutAcceptance}"
          ?checked="${this.areTermsAccepted}">
      </div>
    `;
  }

  /**
   * Updates the state of the checkout terms acceptance flag when the checkbox is checked or unchecked.
   *
   * @param event
   */
  private modifyCheckoutAcceptance(event: InputEvent) {
    this.areTermsAccepted = (event.target as HTMLInputElement).checked;

    emit({
      name: this.eventName,
      element: this,
      bubbles: true,
      detail: {
        id: this.id,
        eventName: this.eventName,
        termsAccepted: this.areTermsAccepted,
      },
    });
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'mhecomm-checkout-terms-acceptance': CheckoutTermsAcceptance;
  }
}
